export default function(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/sourceEvent.js
// module id = 229
// module chunks = 0